export default __webpack_public_path__ + "bea0a370dcdff7ca66d3cd5da20a8c09.png";